(function () {
  const outingPlayersToggleContactFields = function () {
    $('.toggle-contacts').on('click', function(e) {
      window.stopEvent(e);

      const container = $(this).parent().parent().parent();
      container.find('.player-email, .player-phone').toggleClass('d-none');
      const text =
        container.find('.player-email').hasClass('d-none') ? 'Show email and phone fields' : 'Hide email and phone fields'
      $(this).text(text);
    });
  };

  if (typeof window !== "undefined") {
    window.outingPlayersToggleContactFields = outingPlayersToggleContactFields;
  }
})();
